'use client';
import React from 'react';
import { Icon } from '@benzinga/core-ui';
import { SocialSite } from './footerEntity';
import styles from './SocialIcon.module.scss';

const SocialIcon: React.FC<SocialSite> = ({ color, icon, link, name }) => {
  return (
    <a
      aria-label={`Click to check out Benzinga's ${name}`}
      className={`${styles.socialAnchor} ${name}`}
      data-action={`Footer Social Media Click - ${name}`}
      href={link}
      rel="noopener noreferrer"
      style={{ '--hover-color': color } as React.CSSProperties}
      target="_blank"
    >
      <Icon icon={icon} />
    </a>
  );
};
export default SocialIcon;
